import { render, staticRenderFns } from "./DetailedCategorization.vue?vue&type=template&id=b7fcee4c&"
import script from "./DetailedCategorization.vue?vue&type=script&lang=js&"
export * from "./DetailedCategorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports